import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Text } from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import { jsx as _jsx } from "react/jsx-runtime";
var Tooltip = dynamic(_asyncToGenerator(function* () {
  var _yield$import = yield import('@whitbread-eos/atoms'),
    Tooltip = _yield$import.Tooltip;
  return {
    default: Tooltip
  };
}), {
  ssr: false
});
var MAX_TITLE_LENGTH = 39;
export default function HotelTitle(_ref2) {
  var title = _ref2.title,
    testId = _ref2.testId,
    styles = _ref2.styles;
  if (title.length > MAX_TITLE_LENGTH) {
    return _jsx(Tooltip, _objectSpread(_objectSpread({}, _objectSpread(_objectSpread({}, styles), {}, {
      fontWeight: 'regular'
    })), {}, {
      "data-testid": testId,
      description: title,
      variant: "facilities",
      children: _jsx(Text, _objectSpread(_objectSpread({}, styles), {}, {
        children: "".concat(title.slice(0, MAX_TITLE_LENGTH), "...")
      }))
    }));
  }
  return _jsx(Text, _objectSpread(_objectSpread({}, styles), {}, {
    "data-testid": testId,
    children: title
  }));
}